import React, { useState, useEffect } from "react";
import { Navbar, Nav, Form, FormControl, Offcanvas, Button, Container, Row, Col } from "react-bootstrap";
import { FaShoppingCart, FaTrashAlt } from "react-icons/fa";
import logo from "../images/qh-logo.jpg";
import config from "../config.js";
import axios from "axios";
import led from "../images/8.jpg";
import '../style.scss';

function CustomNav() {
  const [consumerProducts, setConsumerProducts] = useState([]);
  const [professionalProducts, setProfessionalProducts] = useState([]);
  const [orderCount, setOrderCount] = useState(0);
  const [orderdata, setOrderdata] = useState([]);
  const [show, setShow] = useState(false);
  const [showSlogan, setShowSlogan] = useState(false);
  const [hoveredProductId, setHoveredProductId] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setShowSlogan(true);
    }, 500);
  }, []);

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}/api/getconsumer`)
      .then((response) => setConsumerProducts(Array.isArray(response.data) ? response.data : []))
      .catch(() => setConsumerProducts([]));

    axios.get(`${config.API_BASE_URL}/api/getprofessional`)
      .then((response) => setProfessionalProducts(Array.isArray(response.data) ? response.data : []))
      .catch(() => setProfessionalProducts([]));

    axios.get(`${config.API_BASE_URL}/api/getorder`)
      .then((response) => setOrderCount(response.data.order_count))
      .catch(console.error);

    axios.get(`${config.API_BASE_URL}/api/getorderbyid`)
      .then((response) => setOrderdata(response.data))
      .catch(console.error);
  }, []);

  const deleteOrder = (id) => {
    axios.get(`${config.API_BASE_URL}/api/order/${id}`)
      .then(() => {
        setOrderdata(orderdata.filter((order) => order.id !== id));
        alert("Order deleted successfully");
        window.location.reload();
      })
      .catch(() => alert("Error deleting order"));
  };

  return (
    <>
      <div className={`slogan-container ${showSlogan ? "show" : ""}`}>
        <p className="animated-slogan">"Bringing Innovation to Light"</p>
      </div>

      <Navbar expand="lg" className="custom-navbar">
        <Navbar.Brand href="#home" className="navbar-brand">
          <img src={logo} alt="QH Lighting" className="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/news">What’s New</Nav.Link>
            <div className="nav-item dropdown custom-dropdown">
              <a href="/product" className="nav-link dropdown-toggle">Products</a>
              <div className="dropdown-menu">
                <div className="dropdown-item dropdown-item-with-arrow">
                  <a href="/consumer-product" className="dropdown-item-with-arrow">Consumer</a>
                  <div className="nested-dropdown-menu">
                    {consumerProducts.map((product) => (
                      <div key={product.id} className="dropdown-item-container"
                        onMouseEnter={() => setHoveredProductId(product.id)}
                        onMouseLeave={() => setHoveredProductId(null)}>
                        <a href={`/ProductList/${product.id}`} className="dropdown-item">
                          {product.category_name || "No category name"}
                        </a>
                        {hoveredProductId === product.id && (
                          <div className="hover-image">
                            <img src={product.image_url || "/images/default.jpg"} alt={product.category_name} />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="dropdown-item dropdown-item-with-arrow">
                  <a href="/professional-product" className="dropdown-item-with-arrow">Professional</a>
                  <div className="nested-dropdown-menu">
                    {professionalProducts.map((product) => (
                      <div key={product.id} className="dropdown-item-container"
                        onMouseEnter={() => setHoveredProductId(product.id)}
                        onMouseLeave={() => setHoveredProductId(null)}>
                        <a href={`/ProductList/${product.id}`} className="dropdown-item">
                          {product.category_name || "No category name"}
                        </a>
                        {hoveredProductId === product.id && (
                          <div className="hover-image">
                            <img src={product.image_url || "/images/default.jpg"} alt={product.category_name} />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                {/* <div className="dropdown-item dropdown-item-with-arrow">
                  <a href="#" className="dropdown-item-with-arrow">Smart Lighting</a>
                </div> */}
                <div className="dropdown-item dropdown-item-with-arrow">
                  <a href="/news" className="dropdown-item-with-arrow">PCB</a>
                </div>
              </div>
            </div>
            <Nav.Link href="/about">About Us</Nav.Link>
            <Nav.Link href="/support">Support</Nav.Link>
            <Nav.Link href="/contact">Contact Us</Nav.Link>
          </Nav>
          <Form className="d-flex search-bar">
            <FormControl type="search" placeholder="Search..." className="me-2" />
          </Form>
          <Nav.Link className="cart-icon" onClick={() => setShow(true)}>
            <FaShoppingCart />
            <span className="cart-badge">{orderCount}</span>
          </Nav.Link>
        </Navbar.Collapse>
      </Navbar>

      <Offcanvas show={show} onHide={() => setShow(false)} placement="end" className="offcanvas-modal">
        <div className="shopping-cart-page" style={{overflowY:"scroll"}}>
<div className="cart-container">
<Offcanvas.Header closeButton>
          <Offcanvas.Title >Shopping Cart</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container>
            <Row>
              {orderdata.map((order, index) => (
                <Col md={12} className="cart-item" key={index}>
                  <img src={order.img} alt="Product" />
                  <div className="cart-details">
                    <p>Order Id: {order.orderid}</p>
                    <h2 className="heading-content">{order.product_model}</h2>
                    <p>Status: {order.status}</p>
                  </div>
                  <div className="remove-section">
                    <div className="price">Rs. {order.price}</div>
                    <FaTrashAlt className="trash-icon" onClick={() => deleteOrder(order.orderid)} />
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
          <Button className="w-100 mt-3" style={{ background:"#143A84", border:"none" }}>
            <a href="/checkoutpage" className="shopping-btn" style={{ color: "white", textDecoration: "none", background:"#143A84", border:"none" }}>
              Checkout
            </a>
          </Button>
        </Offcanvas.Body>
</div>
        </div>
     
      </Offcanvas>
    </>
  );
}

export default CustomNav;
